import { ApiBaseService } from 'api/apibase.service';
import { AxiosPromise } from 'axios';
import { FulfillType } from 'types/cart.types';
import { Upsell } from 'api/products/types';

type UpsellsPayload = {
  orderType: FulfillType;
  date: string;
  store: number;
  productId: number;
};

class ProductApiService extends ApiBaseService {
  getAddons(payload: UpsellsPayload): AxiosPromise<Upsell[]> {
    const today = new Date();
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const dd = String(today.getDate()).padStart(2, '0');
    const yyyy = String(today.getFullYear());

    const badDate = payload.date === '01/01/0001';
    const body: UpsellsPayload = badDate
      ? { ...payload, date: `${mm}/${dd}/${yyyy}` }
      : payload;

    return this.apibase.post(`/products/addons`, body);
  }

  getUpgrades(payload: UpsellsPayload): AxiosPromise<Upsell[]> {
    const today = new Date();
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const dd = String(today.getDate()).padStart(2, '0');
    const yyyy = String(today.getFullYear());

    const badDate = payload.date === '01/01/0001';
    const body: UpsellsPayload = badDate
      ? { ...payload, date: `${mm}/${dd}/${yyyy}` }
      : payload;

    return this.apibase.post(`/products/upgrades`, body);
  }
}

export const productApiService = new ProductApiService();
